import { functions } from './firebase';

function findPlaceDetails(request) {
    const callable = functions.httpsCallable('maps-findPlaceDetails');
    return callable(request);
}

function subscribeNewsletter(request) {
    const callable = functions.httpsCallable('notifications-subscribeNewsletter');
    return callable(request);
}

function addContactUsMessage(request) {
    const callable = functions.httpsCallable('notifications-addContactUsMessage');
    return callable(request);
}

function readBusinessCard(request) {
    const callable = functions.httpsCallable('vision-readBusinessCard');
    return callable(request);
}

function sendGdprUserEmail(request) {
    const callable = functions.httpsCallable('adminEmails-sendGdprUserEmail');
    return callable(request);
}

function createCustomer(request) {
    const callable = functions.httpsCallable('stripe-createCustomer');
    return callable(request);
}

function createSubscription(request) {
    const callable = functions.httpsCallable('stripe-createSubscription');
    return callable(request);
}

function getUserRecord(request) {
    const callable = functions.httpsCallable('userRecord-getUserRecord');
    return callable(request);
}

const cloudFunctions = {
    findPlaceDetails,
    subscribeNewsletter,
    addContactUsMessage,
    readBusinessCard,
    sendGdprUserEmail,
    createCustomer,
    createSubscription,
    getUserRecord
}
export default cloudFunctions;
